import { lazy } from 'react';
import { adaptiveCenterModalOptions } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const SharedPopClipPageContent = lazy(
  () => import('./SharedPopClipPageContent'),
);

export const SharedPopClipPage = wrapLazyNavigatorScreen(
  SharedPopClipPageContent,
  adaptiveCenterModalOptions(),
);
